export default __webpack_public_path__ + "static/media/default-profile.afcbb8f5.svg";